const styles = (theme) => ({
  gridContainer: {
    paddingBottom: '10px',
  },
  barContainer: {
    position: 'relative',
    height: 10,
    borderRadius: 5,
    lineHeight: 0,
    overflow: 'hidden',
    backgroundColor: theme.color.black_14,
  },
  bar: {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    backgroundColor: theme.color.green_7c,
    height: '100%',
  },
  teal: {
    backgroundColor: theme.color.teal_00,
  },
  blue: {
    backgroundColor: theme.color.blue_00,
  },
  yellow: {
    backgroundColor: theme.color.yellow_00,
  },
});

export default styles;
